import React from "react";
import { useAuth } from "../auth/AuthProvider.js";
import { Redirect } from "../../../packages/router/href/Redirect.js";
import { useConfiguration } from "../config/ConfigProvider.js";

/**
 * Container for the front page.
 */
export const FrontPage = () => {
  const { isLoggedIn } = useAuth();
  const { isCloudOnly } = useConfiguration();

  if (isLoggedIn) {
    if (isCloudOnly) {
      return <Redirect to="/cloud" />;
    } else {
      return <Redirect to="/entries" />;
    }
  } else {
    return <Redirect to="/login" />;
  }
};
